export const environmentData = {
  run: "development",
  development: {
    clientId: "18005b60-f981-46c8-b319-6b4e034be7ef",
    authority:
      "https://login.microsoftonline.com/30f52344-4663-4c2e-bab3-61bf24ebbed8/oauth2/v2.0/token",
    tenantId: "30f52344-4663-4c2e-bab3-61bf24ebbed8",
    "api-scope":
      "openid 18005b60-f981-46c8-b319-6b4e034be7ef/user_impersonation",

    apiBaseURL: "https://hm-myntra-api-dev2.azurewebsites.net/api"
  },
  staging: {
    clientId: "18005b60-f981-46c8-b319-6b4e034be7ef",
    authority:
      "https://login.microsoftonline.com/30f52344-4663-4c2e-bab3-61bf24ebbed8/oauth2/v2.0/token",
    tenantId: "30f52344-4663-4c2e-bab3-61bf24ebbed8",
    "api-scope":
      "openid 18005b60-f981-46c8-b319-6b4e034be7ef/user_impersonation",

    apiBaseURL: "https://hm-myntra-api-dev2.azurewebsites.net/api"
  },
  production: {
    clientId: "18005b60-f981-46c8-b319-6b4e034be7ef",
    authority:
      "https://login.microsoftonline.com/30f52344-4663-4c2e-bab3-61bf24ebbed8/oauth2/v2.0/token",
    tenantId: "30f52344-4663-4c2e-bab3-61bf24ebbed8",
    "api-scope":
      "openid 18005b60-f981-46c8-b319-6b4e034be7ef/user_impersonation",
    apiBaseURL: "https://hm-myntra-api-dev2.azurewebsites.net/api"
  },
};
